const EXTERNAL_SOURCE_LOAD_ORIGIN = 'RS_JS_SDK';

export { EXTERNAL_SOURCE_LOAD_ORIGIN };
